import Leger from "../../../../../components/categories/siakad/lms/leger/Home";
export default function Home() {
  
  return (
    <Leger />
  );
}
